import { render, staticRenderFns } from "./DayOfWeekPicker.vue?vue&type=template&id=b83870fe&scoped=true"
import script from "./DayOfWeekPicker.vue?vue&type=script&lang=js"
export * from "./DayOfWeekPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83870fe",
  null
  
)

export default component.exports